import { render, staticRenderFns } from "./ProductStock.vue?vue&type=template&id=f3be546a&scoped=true&"
import script from "./ProductStock.vue?vue&type=script&lang=js&"
export * from "./ProductStock.vue?vue&type=script&lang=js&"
import style0 from "./ProductStock.vue?vue&type=style&index=0&id=f3be546a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3be546a",
  null
  
)

export default component.exports